export class BackorderCommandResult {

    public orderId  : string = '';

    public wasAttempted : boolean = false;
    
    public isLoading : boolean = false;

    public removedFromPickupId : number|undefined = undefined;

    public removedFromDeliveryId : number|undefined = undefined;

    public removedFromProductionRunId : number|undefined = undefined;

    public sentToBackorderApp : boolean|undefined = undefined;

    public error : string|undefined = undefined;

}
